<template>
  <div class="super-container-avise">
    <div class="sub-container-avise">
      <div class="content-container-avise">
        <div class="content-img">
          <img src="https://d1mq21xo4bjiqa.cloudfront.net/images-portal-tutores/Correo/Correo.png" alt="bienestar_azteca_exito"
          class="img-email" />
        </div>
        <div class="content-text">
          <h2 class="text-state">
            Se envío el estado de cuenta del menor al correo electrónico
            <span class="text-state-email">
              {{ emailMask || 'sin correo' }} </span> del padre, madre o tutor.
          </h2>
          <button @click="goToLanding()">Salir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import SessionDataService from '@/core/services/sessionDataService';

const props = defineProps({
  emailSend: {
    type: String,
    default: '',
  },
});
const objSesion = new SessionDataService();
const emailMask = ref(props.emailSend);

onMounted(() => {
  localStorage.clear();
});

const emits = defineEmits(['salir'])
const goToLanding = async () => {
  localStorage.clear()
  await objSesion?.goOffline()
  emits('salir')
}
</script>

<style scoped>
.super-container-avise {
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
  overflow: hidden;
  margin-top: -60px;
}
.sub-container-avise {
  width: 90%;
  margin: auto;
}
.content-container-avise {
  margin: auto;
  width: 90%;
  display: inline-grid;
  justify-content: center;
  align-content: center;
  text-align: center;
  height: auto;
}
.content-img {
  margin: auto;
  width: 350px;
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0px;
}
.img-email {
  width: 100%;
  height: 100%;
}
.content-text {
  width: 55%;
  margin: auto;
}
.text-state {
  font-weight: normal;
  font-size: 20px;
}
.text-state-email {
  font-size: 20px;
  font-weight: 600;
}
button {
  width: 140px;
  height: 45px;
  border-radius: 25px;
  background-color: #0c825e;
  margin: auto;
  margin-top: 40px;
  color: white;
  cursor: pointer;
  outline: 0;
  border: none;
  font-size: 16px;
}
button:focus {
  box-shadow: 0 0 0 0.2rem rgb(12 130 94 / 20%);
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .super-container-avise {
    margin-top: 40px;
    padding-bottom: 60px;
    align-items: flex-start;
  }
  .content-img {
    width: 320px;
    height: 290px;
    margin-bottom: 20px;
  }
  .content-text {
    width: 70%;
  }
  .text-state {
    font-size: 22px;
  }
  .text-state-email {
    font-size: 22px;
  }
  button {
    width: 160px;
    height: 50px;
    font-size: 18px;
    margin-top: 35px;
  }
} 

/* MÓVIL */
@media only screen and (min-width: 200px) and (max-width: 530px) {
  .super-container-avise {
    height: auto;
    padding-bottom: 20px;
    margin-top: 0px;
  }
  .content-img {
    width: 200px;
    height: 180px;
  }
  .content-text {
    width: 85%;
  }
  .content-text .text-state {
    font-size: 16px !important;
  }
  .content-text .text-state .text-state-email {
    font-size: 16px !important;
  }
  button {
    width: 160px;
    height: 48px;
    font-size: 17px;
    margin-top: 30px;
  }
}

@media only screen and (min-width: 350px) and (max-width: 530px) {
  .content-img {
    width: 240px;
    height: 210px;
  }
}

/* LANDSCAPE MÓVIL */
@media only screen and (min-width: 567px) and (max-width: 1025px)
  and (min-height: 300px) and (max-height: 400px)
    and (orientation: landscape) {
  .super-container-avise {
    height: auto;
    padding-bottom: 20px;
    margin-top: -20px;
  }
  .content-text .text-state {
    font-size: 14px !important;
  }
  .content-text .text-state .text-state-email {
    font-size: 14px !important;
  }
}

/* MONITOR GRANDE */
@media only screen and (min-width: 1400px) {
  .super-container-avise {
    margin-top: -40px;
  }
  .content-img {
    width: 550px;
    height: 500px;
  }
  .content-text {
    width: 40%;
  }
  .text-state {
    font-size: 24px;
  }
  .text-state-email {
    font-size: 24px;
  }
  button {
    width: 180px;
    height: 55px;
    font-size: 20px;
  }
}

@media only screen and (min-width: 1920px) {
  .content-img {
    width: 620px;
    height: 580px;
  }
  .content-text {
    width: 35%;
  }
  .text-state {
    font-size: 26px;
  }
  .text-state-email {
    font-size: 26px;
  }
}
</style>